module.exports = __webpack_public_path__ + "static/spokoj_logo_old-75f10d27d7c938c6ef2b51c35ace554a.png";